/**
 * Streaming partial strip — renders the currently in-flight transcript
 * (assistant TTS chunks or interim user STT) below the chat list.
 *
 * Disappears when nothing is streaming.
 */

import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { tokens } from "./styles";

export function LivePartialStrip({ partial }) {
  return (
    <AnimatePresence initial={false}>
      {partial ? (
        <motion.div
          key="live-partial"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.18, ease: "easeOut" }}
          style={{
            borderTop: `1px solid ${tokens.surface.border}`,
            background: "rgba(255, 255, 255, 0.015)",
            padding: "10px 20px",
          }}
          aria-live="polite"
          aria-atomic="false"
        >
          <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
            <div
              style={{
                marginTop: 3,
                display: "flex",
                alignItems: "center",
                gap: 6,
                flexShrink: 0,
              }}
            >
              <span
                style={{
                  position: "relative",
                  width: 6,
                  height: 6,
                  display: "inline-flex",
                }}
              >
                <motion.span
                  animate={{ scale: [1, 1.8, 1], opacity: [0.6, 0, 0.6] }}
                  transition={{
                    duration: 1.4,
                    ease: "easeInOut",
                    repeat: Infinity,
                  }}
                  style={{
                    position: "absolute",
                    inset: 0,
                    borderRadius: "50%",
                    background:
                      partial.role === "user"
                        ? tokens.accent.cyan
                        : tokens.accent.violet,
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    inset: 0,
                    borderRadius: "50%",
                    background:
                      partial.role === "user"
                        ? tokens.accent.cyan
                        : tokens.accent.violet,
                  }}
                />
              </span>
              <span
                style={{
                  fontSize: 10,
                  fontWeight: 600,
                  letterSpacing: "0.14em",
                  textTransform: "uppercase",
                  color:
                    partial.role === "user"
                      ? tokens.accent.cyan
                      : tokens.accent.violet,
                  opacity: 0.85,
                }}
              >
                {partial.role === "user" ? "You" : "Noki"}
              </span>
            </div>
            <p
              style={{
                margin: 0,
                flex: 1,
                fontSize: 14,
                fontStyle: "italic",
                lineHeight: 1.45,
                color: tokens.ink[100],
                opacity: 0.78,
              }}
            >
              {partial.text}
            </p>
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
